// Import markdown files as strings
import creditExtraTimeMd from '../descriptions/credit_extra_time.md?raw';
import offsetOvertimeMd from '../descriptions/offset_overtime.md?raw';
import guaranteedRateMd from '../descriptions/guaranteed_rate.md?raw';
import hourlyPremiumMd from '../descriptions/hourly_premium.md?raw';
import flatRateMd from '../descriptions/flat_rate.md?raw';

export const premiumTypeDescriptions = {
  offset_overtime: offsetOvertimeMd,
  guaranteed_rate: guaranteedRateMd,
  hourly_premium: hourlyPremiumMd,
  flat_rate: flatRateMd,
  credit_extra_time: creditExtraTimeMd,
} as const;

export type PremiumType = keyof typeof premiumTypeDescriptions;
